<template>
  <v-container fill-height wrap>
    <v-flex lg10 offset-md-1 xs12>
      <v-layout :wrap="!$vuetify.breakpoint.mdAndUp" align-center justify-center>
        <v-flex xs6>
          <book-cover :class="!$vuetify.breakpoint.mdAndUp ? 'mb-5' : ''" />
        </v-flex>
        <v-flex xs11>
          <v-card
            :class="'pa-5'"
            :style="'z-index: 1;' + ($vuetify.breakpoint.mdAndUp ? 'margin-left: -50px;' : '')"
            :elevation="'2'"
          >
          <v-card-text :style="($vuetify.breakpoint.mdAndUp ? 'padding-left: 50px;' : '')">
            <book-data class="mb-2" />
            <chapter-list />
          </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<script>
import BookCover from "./BookCover.vue";
import ChapterList from "@/components/chapter/List";
import BookData from "./BookData";

export default {
  components: {
    BookData,
    BookCover,
    ChapterList
  }
};
</script>
